import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import { PromptGroup_deprecated, PromptGroup, Prompt } from '@server/prompts';

export const usePromptLibraryFacade = () => {
  const sweepApi = useSweepApi();

  return {
    get_promptGroups: useCallback(async () => {
      const { data } = await sweepApi.get<PromptGroup[]>('/ai-prompts/prompt-groups');
      return data;
    }, [sweepApi]),

    get_promptGroups_deprecated: useCallback(async () => {
      const { data } = await sweepApi.get<PromptGroup_deprecated[]>(
        '/ai-prompts/prompt-groups-deprecated',
      );
      return data;
    }, [sweepApi]),

    get_prompts: useCallback(async () => {
      const { data } = await sweepApi.get<Prompt[]>('/ai-prompts');
      return data;
    }, [sweepApi]),

    create_promptGroup: useCallback(
      async (payload: Omit<PromptGroup, 'id'>): Promise<PromptGroup> => {
        const { data } = await sweepApi.post<PromptGroup>('/ai-prompts/prompt-groups', payload);
        return data;
      },
      [sweepApi],
    ),

    update_promptGroup: useCallback(
      async (groupId: string, payload: Partial<PromptGroup>) => {
        const { data } = await sweepApi.patch<PromptGroup>(
          `/ai-prompts/prompt-groups/${groupId}`,
          payload,
        );

        return data;
      },
      [sweepApi],
    ),

    delete_promptGroup: useCallback(
      async (groupId: string) => {
        const { data } = await sweepApi.delete<boolean>(`/ai-prompts/prompt-groups/${groupId}`);
        return data;
      },
      [sweepApi],
    ),

    create_prompt: useCallback(
      async (payload: {
        name: string;
        promptText: string;
        promptGroupId?: string;
      }): Promise<Prompt> => {
        const { data } = await sweepApi.post<Prompt>('/ai-prompts', payload);
        return data;
      },
      [sweepApi],
    ),

    update_prompt: useCallback(
      async (promptId: string, payload: Partial<Prompt>) => {
        const { data } = await sweepApi.patch<Prompt>(`/ai-prompts/${promptId}`, payload);
        return data;
      },
      [sweepApi],
    ),

    delete_prompt: useCallback(
      async (promptId: string) => {
        const { data } = await sweepApi.delete<boolean>(`/ai-prompts/${promptId}`);
        return data;
      },
      [sweepApi],
    ),

    optimize_prompt: useCallback(
      async (promptText: string) => {
        const { data } = await sweepApi.post<string>(`/ai-prompts/optimize`, { promptText });
        return data;
      },
      [sweepApi],
    ),
  };
};
